import { PeFormResponseType } from '@app/shared/enums';
import { AclItemApiModel } from '../../AclItemApiModel';

export class PeFormWorkflowStepApiModel {
  public Id: number;
  public FormId: number;
  public Name: string;
  public Acl: Array<AclItemApiModel>;
  public ResponseType: PeFormResponseType;
  public NotifyByEmail: boolean;
  public RestrictByLocation: boolean;
  public RestrictByShift: boolean;
  public RequireWorkflowComment: boolean;
  public RequireNextUserSelection: boolean;

  public deserialize(data): PeFormWorkflowStepApiModel {
    Object.assign(this, data);

    this.Acl = this.Acl.map((x) => new AclItemApiModel().deserialize(x));

    return this;
  }
}
